import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const AnalyticsStore = require('../../stores/AnalyticsStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
import AssignmentAnalyticsOverview from './AssignmentAnalyticsOverview';

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

const defaultProps = {};

class ProjectAssignmentsOverview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            analyticsStoreState: AnalyticsStore.getState(),
            getOverviewActionId: null
        };

        this.getProjectOverview = this.getProjectOverview.bind(this);
        this.unsubscribes = [AnalyticsStore.listen(this.onStoreChange.bind(this, 'analyticsStoreState'))];
    }

    componentDidMount() {
        this.getProjectOverview(this.props.projectId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.projectId !== prevProps.projectId) {
            this.getProjectOverview(this.props.projectId);
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getProjectOverview(projectId) {
        if (!this.state.analyticsStoreState.projectOverviewAnalytics[projectId]) {
            const getOverviewActionId = uuid.v4();
            this.setState({ getOverviewActionId: getOverviewActionId }, () => {
                AnalyticsActions.getProjectOverview(getOverviewActionId, { id: projectId });
            });
        }
    }

    onStoreChange(storeStateName, state) {
        let additionalState = {};
        if (state.action.id === this.state.getOverviewActionId) {
            additionalState.getOverviewActionId = null;
        }

        this.setState({ [storeStateName]: state, ...additionalState });
    }

    render() {
        const self = this;
        const overviewAnalytics = this.state.analyticsStoreState.projectOverviewAnalytics[this.props.projectId];
        if (!overviewAnalytics) {
            return null;
        }

        return <AssignmentAnalyticsOverview overviewAnalytics={overviewAnalytics} />;
    }
}

ProjectAssignmentsOverview.propTypes = propTypes;
ProjectAssignmentsOverview.defaultProps = defaultProps;

export default ProjectAssignmentsOverview;
